module.exports = __webpack_public_path__ + "static/media/base-camp.d19a4d2e.png";